/* eslint-disable camelcase */
import { DOCUMENT_ERROR_MESSAGES, DEFAULT_ERROR_MESSAGE } from '../constants/documents';

interface ApolloError {
  graphQLErrors?: Array<{
    extensions?: {
      error_code?: string;
    };
  }>;
}

export const getErrorMessage = (error: unknown): string => {
  // Check if it's an Apollo error with GraphQL errors
  const apolloError = error as ApolloError;
  
  if (apolloError?.graphQLErrors?.length > 0) {
    const graphQLError = apolloError.graphQLErrors[0];
    
    // Check for backend error codes
    const errorCode = graphQLError?.extensions?.error_code;
    if (errorCode) {
      const messages = DOCUMENT_ERROR_MESSAGES as Record<string, string>;
      return messages[errorCode] || DEFAULT_ERROR_MESSAGE;
    }
  }

  // Return default message for all other cases
  return DEFAULT_ERROR_MESSAGE;
};
